import React, {useEffect, useState} from 'react'
import Box from '@mui/material/Box';
import { useParams } from "react-router";
import LoadingPageIndicator from '../../../../components/LoadingPageIndicator';
import { Transaction, User } from '../../../../models';
import TransactionView from './transaction-view.component';
import api, { ViewRequest } from '../../../../api/medAppApi';
import { useDispatch } from 'react-redux';

import { putMessage } from '../../../app/store/actions';


const TransactionViewPage: React.FC<{
    load?: boolean;
  }> = ({
    load = false
  }) => {
    const dispatch = useDispatch();
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [shouldLoad, setShouldLoad] = useState(load);
    const [isLoading, setIsLoading] = useState(true);
    const [transaction, setTransaction] = useState<Transaction | undefined>();
    const [initiatedBy, setInitiatedBy] = useState<User | undefined>()
    const [toPay, setToPay] = useState<User | undefined>()
    let { id } = useParams<{ id: string }>();
   
    const check = async (modelId: number) => {
        setIsLoading(true);
        try {
            const criteria: ViewRequest = {
                modelName: 'transaction',
                modelId
              };
          let ans = await api.viewModel<Transaction>(criteria);
          if (ans.code === 200) {
            let {payload} = ans.data!.data;
            let ans2 = await api.getUserFromId({modelName: payload!.AssociatedWith.toLowerCase() as any, modelId: payload!.userId as any});
            if(payload?.inPaymentTo !== "Webmaster"){
              let ans3 = await api.getUserFromId({modelName: payload!.inPaymentTo.toLowerCase() as any, modelId: payload!.toPayId as any});
              setToPay(ans3.data!.data.payload as User)

            }
            setInitiatedBy(ans2.data!.data.payload as User);
            setTransaction(ans.data!.data.payload);
          }
          else {
            console.log(ans);
            throw new Error("Cannot Load data");
          }
  
        } catch (err) {
          console.log(err);
          dispatch(
            putMessage({
              type: "error",
              message: "Failed to load data",
            })
          );
        }
        setIsLoading(false)
      }

      useEffect(() => {
        if (shouldLoad) {
          let modelId = parseInt(id!);
          if (isNaN(modelId)) {
            console.error('No valid id found');
            dispatch(
                putMessage({
                  type: "error",
                  message: "Failed to load data",
                })
              );
            return;
          }
          check(modelId)
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [shouldLoad, id]);
    return (
        <Box sx={{
            width: {
              md: '80vw',
              sm: '100%'
            },
            maxWidth: '800px',
            minWidth: '250px',
            pl: 2
          }}>
          {transaction && <TransactionView transaction={transaction} initiatedBy={initiatedBy!} toPay={toPay} />}
          {isLoading && <LoadingPageIndicator />}
    
          </Box>
    )
}

export default TransactionViewPage